_collow.components.AssessmentPage = class AssessmentPage extends (
    _collow.components.Base
  ) {
    root;
    elements;
    params;
  
    constructor(root, elements, params) {
      super();
  
      this.root = root;
      this.elements = elements;
      this.params = params;

      this.fetchResults()

      // window.onload = () => {
      //   const userId = this.getUserId();
      //   this.getCadidateScores(userId)
      //     .then(({pc2, pc3}) => {
      //       const distances = this.calculateDistances(pc2, pc3);
      //       this.renderBarChart(distances);
      //     })
      //     .catch((error) => console.error('Error fetching user data:', error));
      // };
    }

    // getUserId = () => {
    //   return 159749
    // }
  
    getCadidateScores = async (userId) => {
      try {
        const url = `https://neurolympics.nl/api/v2/campaigns/989/candidates/${userId}/scores`
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': 'eyJraWQiOiJoczUxMjk3OTAzNDM2N2VjNiIsImFsZyI6IkhTNTEyIn0.eyJzdWIiOiIzNTMiLCJ1X3R5cGUiOiJQQVJUTkVSIiwiaWF0IjoxNzI1OTY5NTk5fQ.4TtXW8ALE_XxZJv0OMih6LLmwbytFQTWk2RKN8aeu2FmEU50iJlpri1jmSioGJ8p2KSGHkbvOAFCpo438mOhBQ'
          }
        })
        const data = await response.json()
        const pc2 = data.gameBatteries[0].modelScores.filter(model => model.type === "ISCO_PC2")[0].scaledScore
        const pc3 = data.gameBatteries[0].modelScores.filter(model => model.type === "ISCO_PC3")[0].scaledScore
        return {pc2, pc3}
      } catch (error) {
        console.log(error.message)
      }
    }

    calculateDistance = (x1, y1, x2, y2) => {
      const dx = x2 - x1;
      const dy = y2 - y1;
      return Math.sqrt(dx * dx + dy * dy);
    }

      /**
     * Check if assessment feature is enabled
     * @returns {boolean} Whether assessment is enabled
     */
    checkHasAssessment = () => {
      let features = JSON.parse(window.localStorage.getItem('whitelabelFeatures') || '{}');
      return features?.has_assessment ?? false;
    }

    calculateDistances = (pc2, pc3) => {
      if (!this.checkHasAssessment()) return; 

      const profiles = {
        Softwareontwikkelaars: { pc2: 44, pc3: 2 },
        Webdesigner: { pc2: 43, pc3: 5 },
        ERPprogrammeur: { pc2: 40, pc3: 1 },
        DatabaseSpecialist: { pc2: 48, pc3: 3 },
        Systeembeheerders: { pc2: 85, pc3: 0 },
        DataEngineer: { pc2: 52, pc3: 8 },
        Helpdeskmedewerker: { pc2: 55, pc3: 7 },
        Webmaster: { pc2: 57, pc3: 1 }, 
        Procesanalist: { pc2: 56, pc3: 31 },
        DataEntryMedewerker: { pc2: 16, pc3: 33 },
        SoftwareTester: { pc2: 45, pc3: 28 }, 
        MechatronicaEngineer:{ pc2: 79, pc3: 16 },
        ComputerHardwareSupport: { pc2: 85, pc3: 28 },
      }
      
      const distances = {};
      for (const profile in profiles) {
        const profileCoords = profiles[profile];
        distances[profile] = this.calculateDistance(pc2, pc3, profileCoords.pc2, profileCoords.pc3);
      }
    
      return distances;
    }

    renderBarChart = (data) => {
      if (!this.checkHasAssessment()) return; 
      const chart = document.querySelector('.bar-chart');
      chart.innerHTML = ''; 

      const values = Object.keys(data).map(profile => {
        return { profile, value: Math.round(100 - data[profile]) };
      });

      values.sort((a, b) => b.value - a.value);
  
      values.forEach(({ profile, value }) => {
        const barRow = document.createElement('div');
        barRow.classList.add('bar-row');
        barRow.classList.add(profile);

        const ancorIcon = document.createElement('a');
    
        const labelIcon = document.createElement('i');
        labelIcon.classList.add('fa-solid', 'fa-up-right-from-square', 'fa-xs');
        labelIcon.style.color = '#7c3ca5';
        
        const ancor = document.createElement('a');
        ancor.innerText = `${this.params.linktext} >`;

        const label = document.createElement('div');
        label.classList.add('label');

        const isCollow = ["Collow"].includes(this.params.project);
        const link = isCollow ? "/courses" : "/";

      switch(profile) {
        case "Softwareontwikkelaars":
          label.innerText = "Softwareontwikkelaars";
          ancor.href = `${link}?tags=Softwareontwikkelaars`;
          ancorIcon.href = `${link}?tags=Softwareontwikkelaars`;
          break;
        case "Webdesigner": 
          label.innerText = "Webdesigner";
          ancor.href = `${link}?tags=Webdesigner`;
          ancorIcon.href = `${link}?tags=Webdesigner`;
          break;
        case "ERPprogrammeur":  
          label.innerText = "ERP programmeur";
          ancor.href = `${link}?tags=ERP-programmeur`;
          ancorIcon.href = `${link}?tags=ERP-programmeur`;
          break;
        case "DatabaseSpecialist":  
          label.innerText = "Database specialist";
          ancor.href = `${link}?tags=Database-specialist`;
          ancorIcon.href = `${link}?tags=Database-specialist`;
          break;
        case "Systeembeheerders":  
          label.innerText = "Systeembeheerders";
          ancor.href = `${link}?tags=Systeembeheerders`;
          ancorIcon.href = `${link}?tags=Systeembeheerders`;
          break;
        case "DataEngineer":  
          label.innerText = "Data engineer";
          ancor.href = `${link}?tags=Data-engineer`;
          ancorIcon.href = `${link}?tags=Data-engineer`;
          break;
        case "Helpdeskmedewerker":  
          label.innerText = "Helpdeskmedewerker";
          ancor.href = `${link}?tags=Helpdeskmedewerker`;
          ancorIcon.href = `${link}?tags=Helpdeskmedewerker`;
          break;
        case "Webmaster":  
          label.innerText = "Webmaster";
          ancor.href = `${link}?tags=Webmaster`;
          ancorIcon.href = `${link}?tags=Webmaster`;
          break;
        case "Procesanalist":  
          label.innerText = "Procesanalist";
          ancor.href = `${link}?tags=Procesanalist`;
          ancorIcon.href = `${link}?tags=Procesanalist`;
          break;
        case "DataEntryMedewerker":  
          label.innerText = "Data-entry medewerker";
          ancor.href = `${link}?tags=Data-entry-medewerker`;
          ancorIcon.href = `${link}?tags=Data-entry-medewerker`;
          break;
        case "SoftwareTester":  
          label.innerText = "Software tester";
          ancor.href = `${link}?tags=Software-tester`;
          ancorIcon.href = `${link}?tags=Software-tester`;
          break;
        case "MechatronicaEngineer":  
          label.innerText = "Mechatronica Engineer";
          ancor.href = `${link}?tags=Mechatronica-Engineer`;
          ancorIcon.href = `${link}?tags=Mechatronica-Engineer`;
          break;
        case "ComputerHardwareSupport":  
          label.innerText = "Computer & hardware support";
          ancor.href = `${link}?tags=hardware-support`;
          ancorIcon.href = `${link}?tags=hardware-support`;
          break;
        }
    
        const barContainer = document.createElement('div');
        barContainer.classList.add('bar-container');
        const bar = document.createElement('div');
        bar.classList.add('bar');
        bar.style.width = `${value}%`;

        ancorIcon.appendChild(labelIcon);
        label.appendChild(ancorIcon);
        barContainer.appendChild(bar);
        barRow.appendChild(label);
        barRow.appendChild(barContainer);
        barRow.appendChild(ancor);
        chart.appendChild(barRow);
      });
    }

    inviteWLToBrainsfirst = async () => {
      if (!this.checkHasAssessment()) return; 
      const userInfo = JSON.parse(localStorage.getItem("progressJson"))

      //Code must work only if the user has a firstname
      if (!userInfo.firstname) {
        _collow.Notify.info(this.params?.errorNoName,
        {
          actionLabel: this.params?.errorNoNamelink,
          href: this.origin + '/profile/settings'
        })
      }
      try {
        const token = localStorage.getItem("token")
        const response = await fetch(this.params.path + '/brainsfirst/invite', {
          method: 'POST',
          headers: {
            'Authorization': `${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }

        if (response.status === 200) {
          _collow.Notify.info(this.params?.infoSuccesMessage);
        }

      } catch(e) {
        console.error('The following error has occured ' + e)
      }
    }
    
    fetchResults = () => {
      const token = localStorage.getItem("token")
      const isWhiteLable = !["Collow"].includes(this.params.project);

      fetch( this.params.path + "/brainsfirst/assessment_results", {
        method: 'GET',
        headers: {
          'Authorization': `${token}`,
          'Content-Type': 'application/json',
        }
      }).then(res => {
        if (!res.ok) {
          const error = new Error(res.statusText);
          error.status = res.status;
          throw error;
        }
          return res.json()
        }).then(data => {
          let pc2
          let pc3
          data.forEach(coord => {
            if(coord.type === "ISCO_PC2") {
              pc2 = coord.scaledScore
            } else {
              pc3 = coord.scaledScore
            }
          })
          const distances = this.calculateDistances(pc2, pc3);
          this.renderBarChart(distances);
        }).catch(error => {
          if(error.status == 404) {
            this.setDefaultChart()
            this.showPurchaseScreen()
            if (!isWhiteLable) return;
            this.assessmentButtonWL()
          }})
    }

    showPurchaseScreen = () => {
      const assessmentScreen = document.querySelector(".assessmentdashboard__structure")
      assessmentScreen.classList.add("purchase")
    }

    setDefaultChart = () => {
      const distances = this.calculateDistances(33, 42);
      this.renderBarChart(distances);

    }

    assessmentButtonWL = () => {
      const button = this.root.querySelector("a.button-simple-purple");
      if (button) {
        button.addEventListener("click", () => {
          button.removeAttribute("href");
          this.inviteWLToBrainsfirst();
        });
      }
    }
};
  
   
  
  
  
  
  
  